(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer-bar"] && !Shopify.designMode) return;
  try {
    
    (function () {
      const bar = document.querySelector('[data-countdown-bar][data-end-epoch="{{ end_epoch }}"]') || document.querySelector('[data-countdown-bar]');
      if (!bar) return;

      const output = bar.querySelector('[data-countdown-output]');
      const afterWrap = bar.querySelector('[data-countdown-after]');
      const isMock = bar.dataset.mock === 'true';
      const afterEnds = bar.dataset.afterEnds || 'show_text';
      const endEpoch = parseInt(bar.dataset.endEpoch || '0', 10);

      // Mock countdown: start at 2d 2h 55m 15s (your screenshot)
      let mockRemaining = (2 * 86400) + (2 * 3600) + (55 * 60) + 15;

      const pad2 = (n) => String(Math.max(0, n)).padStart(2, '0');

      function setParts(totalSeconds) {
        const d = Math.floor(totalSeconds / 86400);
        const h = Math.floor((totalSeconds % 86400) / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = Math.floor(totalSeconds % 60);

        output.querySelector('[data-d]').textContent = pad2(d);
        output.querySelector('[data-h]').textContent = pad2(h);
        output.querySelector('[data-m]').textContent = pad2(m);
        output.querySelector('[data-s]').textContent = pad2(s);
      }

      function onExpired() {
        if (afterEnds === 'hide') {
          bar.style.display = 'none';
          return;
        }

        // show after-text (if present), and freeze timer at 00
        setParts(0);
        if (afterWrap) afterWrap.hidden = false;
      }

      function tick() {
        if (isMock) {
          setParts(mockRemaining);
          mockRemaining = Math.max(0, mockRemaining - 1);
          if (mockRemaining <= 0) onExpired();
          return;
        }

        // If no end date provided, just keep zeros (don’t hide the bar)
        if (!endEpoch || Number.isNaN(endEpoch)) {
          setParts(0);
          return;
        }

        const now = Math.floor(Date.now() / 1000);
        const remaining = endEpoch - now;

        if (remaining <= 0) {
          onExpired();
        } else {
          setParts(remaining);
        }
      }

      tick();
      setInterval(tick, 1000);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collection-image-wrapper').forEach(function(wrapper) {
    const mobileSize = wrapper.getAttribute('data-mobile-size');
    if (window.innerWidth <= 749 && mobileSize === '2x1') {
      wrapper.classList.add('collection-image--mobile-2x1');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterPopup {
    constructor(element) {
      this.element = element;
      this.popupId = element.dataset.popupId;
      this.delay = element.dataset.delay;
      this.storageKey = `popup-closed-${this.popupId}`;
      this.closeButton = element.querySelector('.newsletter-popup__close');
      this.overlay = element.querySelector('.newsletter-popup__overlay');
      this.form = element.querySelector('.newsletter-popup__form');
      this.isDesignMode = element.classList.contains('newsletter-popup--preview');

      this.init();
    }

    init() {
      if (this.isDesignMode) {
        this.closeButton.addEventListener('click', () => this.close());
        return;
      }

      if (sessionStorage.getItem(this.storageKey)) return;

      this.closeButton.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      if (this.form) {
        this.form.addEventListener('submit', () => {
          sessionStorage.setItem(this.storageKey, 'true');
        });
      }

      this.show();
    }

    show() {
      const delays = { immediate: 0, '10s': 10000, scroll: null, idle: 60000 };
      const delayTime = delays[this.delay];

      if (this.delay === 'scroll') {
        this.setupScrollTrigger();
      } else {
        setTimeout(() => {
          this.element.style.display = 'block';
          requestAnimationFrame(() => this.element.classList.add('is-visible'));
        }, delayTime);
      }
    }

    setupScrollTrigger() {
      const checkScroll = () => {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrollPercent > 80) {
          this.element.style.display = 'block';
          requestAnimationFrame(() => this.element.classList.add('is-visible'));
          window.removeEventListener('scroll', checkScroll);
        }
      };
      window.addEventListener('scroll', checkScroll);
    }

    close() {
      this.element.classList.remove('is-visible');
      if (!this.isDesignMode) sessionStorage.setItem(this.storageKey, 'true');
      setTimeout(() => { this.element.style.display = 'none'; }, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.newsletter-popup').forEach((popup) => new NewsletterPopup(popup));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-float"] && !Shopify.designMode) return;
  try {
    
/* scroll-float: handled by inline script above */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-promotion-popup"] && !Shopify.designMode) return;
  try {
    
    class TextPromotionPopup {
      constructor(element) {
        this.element = element;
        this.popupId = element.dataset.popupId;
        this.delay = element.dataset.delay;
        this.storageKey = `popup-closed-${this.popupId}`;
        this.closeButton = element.querySelector('.text-promotion-popup__close');
        
        this.init();
      }

      init() {
        if (sessionStorage.getItem(this.storageKey)) {
          return;
        }

        this.closeButton.addEventListener('click', () => this.close());

        this.show();
      }

      show() {
        const delays = {
          'immediate': 0,
          '10s': 10000,
          'scroll': null,
          'idle': 60000
        };

        const delayTime = delays[this.delay];

        if (this.delay === 'scroll') {
          this.setupScrollTrigger();
        } else {
          setTimeout(() => {
            this.element.style.display = 'block';
            requestAnimationFrame(() => {
              this.element.classList.add('is-visible');
            });
          }, delayTime);
        }
      }

      setupScrollTrigger() {
        const checkScroll = () => {
          const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
          
          if (scrollPercent > 80) {
            this.element.style.display = 'block';
            requestAnimationFrame(() => {
              this.element.classList.add('is-visible');
            });
            window.removeEventListener('scroll', checkScroll);
          }
        };

        window.addEventListener('scroll', checkScroll);
      }

      close() {
        this.element.classList.remove('is-visible');
        sessionStorage.setItem(this.storageKey, 'true');
        
        setTimeout(() => {
          this.element.style.display = 'none';
        }, 300);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      const popups = document.querySelectorAll('.text-promotion-popup');
      popups.forEach(popup => new TextPromotionPopup(popup));
    });
  
  } catch(e) { console.error(e); }
})();
})();
